import React from 'react';
import PropTypes from 'prop-types';

const CheckBox = (props) => {
    const { id, label, className, disableClass, disabled, checked, testId, ...rest } = props;

    const wrapperClass = ['u_checkbox', className || '', checked ? 'u_checkbox-checked' : '', disableClass ? 'u_disabled' : '', disabled ? 'u_btn-disabled' : '',].filter(Boolean).join(' ');

    return (
        <React.Fragment>
            <div className={wrapperClass} onClick={e => e?.stopPropagation()}>
                <input id={id} type="checkbox" checked={checked} disabled={disabled} data-testid={testId}{...rest}/>
                <label htmlFor={id}><span>{label}</span></label>
            </div>
        </React.Fragment>
    );
};

CheckBox.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    testId: PropTypes.string,
};
CheckBox.defaultProps = {
    id: 'u_chk',
    label: 'Checkbox',
    testId: undefined,
};

export default CheckBox;
